export const APP_DOWNLOAD_LINK = {
	googlePlayStore:
		"https://play.google.com/store/apps/details?id=jp.healthandrights.coyomiv2&hl=ja",
	appStore:
		"https://apps.apple.com/jp/app/%E3%82%B1%E3%82%A2%E3%83%9F%E3%83%BC-pms%E4%BA%88%E6%B8%AC-%E5%85%B1%E6%9C%89%E3%82%A2%E3%83%97%E3%83%AA/id1505033077",
};
